export const Indicator = (props) => (
  <svg width="114" height="5" viewBox="0 0 114 5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="42" width="30" height="5" rx="2.5" fill="#1D1C1C"/>
    <rect x="80" width="13" height="5" rx="2.5" fill="#BAB9BD"/>
    <rect x="101" width="13" height="5" rx="2.5" fill="#BAB9BD"/>
    <rect width="13" height="5" rx="2.5" fill="#BAB9BD"/>
    <rect x="21" width="13" height="5" rx="2.5" fill="#BAB9BD"/>
  </svg>
)

export const BackIcon = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 24V0L0 0V24H24Z" fill="transparent"/>
    <path d="M8.293 12.707C8.10553 12.5195 8.00022 12.2652 8.00022 12C8.00022 11.7348 8.10553 11.4805 8.293 11.293L14.293 5.29301C14.4816 5.11085 14.7342 5.01006 14.9964 5.01234C15.2586 5.01461 15.5094 5.11978 15.6948 5.30519C15.8802 5.4906 15.9854 5.74141 15.9877 6.00361C15.99 6.26581 15.8892 6.51841 15.707 6.70701L10.414 12L15.707 17.293C15.8892 17.4816 15.99 17.7342 15.9877 17.9964C15.9854 18.2586 15.8802 18.5094 15.6948 18.6948C15.5094 18.8802 15.2586 18.9854 14.9964 18.9877C14.7342 18.99 14.4816 18.8892 14.293 18.707L8.293 12.707Z" fill="black"/>
  </svg>
)